
import {ExchangeApi} from '@/api'
import {DailyApi} from '@/api'
import {RecommendApi} from '@/api'
import {BottomBannerApi} from '@/api'
import {TopBannerApi} from '@/api'
import VChart from 'vux/src/components/v-chart/v-chart.vue'


export default {
name: "Qx",
components: {
VChart
},
data() {
return {
countDownTimer: null,
text2019: ".text2019",
text2: ".text2",
localSecond: 0,
baseList: [],
demo01_index: 0,
swiperItemIndex: 1,
showFlag: false,
borderStyle: ".borderStyle",
borderStyle2: ".borderStyle2",
minutes: 30,
seconds: 0,
changeCashList: {},
demo06_index: 0,
myseconds: "",
moveMin: "",
ele1: "",
ele2: "",
myDailyList: [],
myRecommendList: [],
myTopBannerList: [],
myCenterBannerList: [],
myBottomBannerList: [],

percent: 0,
icircle: 0,
swiperOptionTop: {
loop: true,
observer:true,//修改swiper自己或子元素时，自动初始化swiper
observeParents:true,//修改swiper的父元素时，自动初始化swiper
autoplay: {
delay: 3000,
stopOnLastSlide: false,
disableOnInteraction: false
},
on: {

click: () => {
const swiperItem = this.$refs.topSwiper.swiper.clickedSlide
const item = this.myTopBannerList[swiperItem.getAttribute('data_index')]
console.log('hhh---,click', item)
this.tianzhuan(item)
}
}
},
swiperOptionCenter: {
spaceBetween: -50,
loop: true,
slidesPerView: 2,
observer:true,//修改swiper自己或子元素时，自动初始化swiper
observeParents:true,//修改swiper的父元素时，自动初始化swiper
autoplay: {
delay: 3000,
stopOnLastSlide: false,
disableOnInteraction: false
},
on: {

click: () => {
const swiperItem = this.$refs.centerSwiper.swiper.clickedSlide
const item = this.myCenterBannerList[swiperItem.getAttribute('data_index')]
console.log('hhh---,click', item)
this.tianzhuan(item)
}
}
}
}
},
filters: {
formateTime: function (val) {
return Math.floor(val / 60);
}
},
created() {
let appType = this.$route.query.appType
let auth = this.$route.query.auth
let deviceid = this.$route.query.deviceid
let channel = this.$route.query.channel
let appid = this.$route.query.appid
let appVersion = this.$route.query.appVersion
let apiVersion = this.$route.query.apiVersion
let appKey = this.$route.query.appKey
window.localStorage.setItem("appType", appType);
window.localStorage.setItem("auth", auth);
window.localStorage.setItem("deviceid", deviceid);
window.localStorage.setItem("channel", channel);
window.localStorage.setItem("appid", appid);
window.localStorage.setItem("appVersion", appVersion);
window.localStorage.setItem("apiVersion", apiVersion);
window.localStorage.setItem("appKey", appKey);
this.getData()
},
mounted() {


window.reload = this.reload
},
methods: {
reload() {
console.log('hhh---,evaluateJavascript reload success!!!')
this.getData()
},
getData() {
ExchangeApi.getExchangeList({
key: 'exchangeList'
}).then(data => {
if (data.Status === 200) {
this.percent = 0
this.icircle = 0
this.changeCashList = data.Result
this.myseconds = this.changeCashList.seconds
this.icircle = Math.floor((100 / this.myseconds * 1000)) / 1000
this.percent = this.percent - this.icircle
if (this.myseconds > 0) {
this.showFlag = true
}
if (this.myseconds === 0) {
this.showFlag = false;
}
this.ele1 = Math.floor(this.myseconds / 60);
this.ele2 = (this.myseconds - Math.floor(this.myseconds / 60) * 60);
this.minutes = this.ele1;
this.seconds = this.ele2;
this.startCountDown();
}
})
DailyApi.getDailyTask({
key: 'dailyTask',
type: '1'
}).then(data => {
this.myDailyList = data.Result.list;
})
RecommendApi.getRecommendTask({
key: 'recommendTask',
type: '2'
}).then(data => {
this.myRecommendList = data.Result.list;
})
BottomBannerApi.getBottomBannerList({
cateTag: "TaskBottomBanner",
type: '2'
}).then(data => {
this.myBottomBannerList = data.Result.list;
})
TopBannerApi.getTopBannerList({
cateTag: "TaskHeadBanner"
}).then(data => {
this.myTopBannerList = data.Result.list;
if (this.myTopBannerList && this.myTopBannerList.length <= 1) {
this.swiperOptionTop.autoplay = false
this.swiperOptionTop.loop = false
}
})
TopBannerApi.getTopBannerList({
cateTag: "TaskCenterBanner"
}).then(data => {
this.myCenterBannerList = data.Result.list;
})
},
renderChart({chart}) {
const data = [{x: '1', y: 100}]
chart.source(data, {
y: {
max: 100,
min: 0
}
})
chart.axis(false)
chart.tooltip(false)
chart.coord('polar', {
transposed: true,
innerRadius: 0.1,
radius: 0.65
})
chart.guide().arc({
start: [0, 0],
end: [1, 99.98],
top: false,
style: {
lineWidth: 3,
stroke: '#ccc'
}
})
chart.guide().text({
position: ['50%', '50%'],
content: '100',
style: {
fontSize: 20,
fill: '#1890FF'
}
})
chart.interval()
.position('x*y')
.size(2)
.animate({
appear: {
duration: 12000,
easing: 'cubicIn'
}
})
chart.render()
},
tianzhuan: function (item) {
_hmt.push(['_trackEvent', item.Name, item.Id]);
window.jibu.jumpAppPage(item.JumpUrl);
},
tianzhuans: function (item) {
console.log(item.Name)
_hmt.push(['_trackEvent', item.Name, item.Id]);
window.jibu.jumpAppPage(item.JumpUrl);
},
advertising: function (item) {
_hmt.push(['_trackEvent', item.Name, item.Id]);
window.jibu.jumpAppPage(item.JumpUrl);
},
demo06_onIndexChange(index) {
this.demo06_index = index
},
demo01_onIndexChange(index) {
this.demo01_index = index
},
showRecommendDialog: function () {

},
showCountDownDialogJs: function () {
window.jibu.showCountDownDialog(this.localSecond);
},
refreshCoin: function () {
window.location.reload();
},
testClick: function () {
_hmt.push(['_trackEvent', "兑换现金", "testClick"]);
window.jibu.showChangeCashDialog();

},

getRedBagDialog: function () {
_hmt.push(['_trackEvent', "签到拆红包", "getRedBagDialog"]);
window.jibu.showGetRedBagDialog();
},
num: function (n) {
return n < 10 ? '0' + n : '' + n
},
startCountDown: function () {
const _this = this
if (_this.countDownTimer) {
window.clearInterval(_this.countDownTimer)
}
_this.countDownTimer = window.setInterval(function () {
if (_this.seconds === 0 && _this.minutes !== 0) {
_this.seconds = 59
_this.minutes -= 1
} else if (_this.minutes === 0 && _this.seconds === 0) {
_this.showFlag = false;
_this.seconds = 0
_this.percent = 0
_this.icircle = 0
window.clearInterval(_this.countDownTimer)
} else {
_this.seconds -= 1
}
_this.localSecond = _this.minutes * 60 + _this.seconds
}, 1000)
},
addReward: function () {

},
},
watch: {
second: {
handler(newVal) {
this.num(newVal)
}
},
minute: {
handler(newVal) {
this.num(newVal)
}
}
},
computed: {
color() {
let color = '#FF8F08';
return color;
},
second: function () {
this.percent += this.icircle;
return this.num(this.seconds)
},
minute: function () {
return this.num(this.minutes)
}
}
}



// WEBPACK FOOTER //
// ./src/pages/Qx.vue